import fclone from 'fclone';
export function cloneDeep(value) {
  return fclone(value);
}